import { Component, OnInit, OnDestroy, ComponentFactoryResolver, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IGridOptions, IColumnOptions } from '@framework/interfaces/IEntity';
import { Subscription } from '@node_modules/rxjs';
import { FormBuilderControl } from '@common/formbuilder/FormBuilderControl';
import { FormBuilderControlType } from '@common/formbuilder/FormBuilderControlType';
import { ViewType } from '@framework/core/Enums';
import { NbToastrService } from '@nebular/theme';
import { ConfirmationService } from 'primeng/api';
import { MfTableComponent } from '../mf-table/mf-table.component';

@Component({
  selector: 'mf-master-detail',
  templateUrl: './mf-master-detail.component.html',
  styleUrls: ['./mf-master-detail.component.css']
})
export class MasterDetailComponent implements OnInit, OnDestroy {
  @ViewChild('masterDetailLazyTable', { static: true }) lazyTable: MfTableComponent;
  @ViewChild('detailHost', { static: true }) detailHost: ViewContainerRef;
  @ViewChild('addNewDialog', { static: true }) addNewDialog: ViewContainerRef;
  protected masterDetailComponentHeader: string = null;
  protected masterDetailComponentHeaderDescription: string = "All";
  protected masterDetailComponentList: IGridOptions;
  protected masterDetailComponentDetailsRouteUrl: string;
  protected masterDetailComponentDetailEntity: any;
  protected masterDetailComponentDetailComponent: any;
  get canDeleteItem() {
    return this.canDelete
  };
  protected canDelete: boolean = false;
  protected hideAddButton: boolean = false;
  protected hideRefreshButton: boolean = true;
  private _subscriptions: Array<Subscription> = new Array<Subscription>();
  private _selectedItem: any = null;
  private _selectedColumns: any[];
  private _currentFilters: any[];
  private _detailComponentLoaded: boolean = false;
  private _addNewDialogComponentLoaded: boolean = false;
  private _component: any;
  public listIndex; any;
  private _addNewComponent: any;
  private _entityId: any;
  public parent: any;
  public lookupValues: any;
  public items: Array<any>;
  public loading: boolean = false;
  public staticColumns: any[];
  public columns: any[];
  public advancedFilters: any[] = [];
  public filterActive: boolean = false;
  public columnPopupVisible: boolean = false;
  public advancedPopupVisible: boolean = false;
  public addNewPopupVisible: boolean = false;
  public filterCount: number;
  private columnsSet: any = false;
  public get entityId() { return this._entityId };
  public set entityId(value) { this._entityId = value; this.loadData(); }
  public get componentHeader(): string { return this.selectedItem && this._component && this._component.header ? this._component.header : null };
  public get entityName(): string { return this.list.model.displayName.split("|")[0] };
  public get header(): string { if (!this.masterDetailComponentHeader) this.masterDetailComponentHeader = this.list.model.displayName.split("|")[1]; return this.masterDetailComponentHeader };
  public get headerDescription(): string { return this.masterDetailComponentHeaderDescription };
  public get list(): IGridOptions { return this.masterDetailComponentList };
  public get detailsRouteUrl(): string { return this.masterDetailComponentDetailsRouteUrl };
  public get selectedColumns() { return this._selectedColumns; }
  public set selectedColumns(value) { this._selectedColumns = value; }
  public get selectedItem() { return this._selectedItem; }
  public set selectedItem(value) {
    var tempVal = this._selectedItem;
    this._selectedItem = value;
    if (value && value.id) {
      //if (tempVal && tempVal.id == value.id)
      //  return;
      if (this.detailsRouteUrl)
        this.router.navigate([this.detailsRouteUrl, { id: value.id }]);
      else {
        if (!this._detailComponentLoaded)
          this.loadDetailComponent();
        this._component.entityId = value.id;
      }
    }


  }
  public loadEntity() {
  this.loadData();
  }
  public get canSave(): boolean { return this._component && this._component.save ? true : false; };
  public get canAdd(): boolean { return !this.hideAddButton && this.list.endPoints && (this.list.endPoints.insert ? true : false) };
  public get canRefresh(): boolean { return !this.hideRefreshButton }
  public constructor(private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver,
    private messageService: NbToastrService,
    private confirmationService: ConfirmationService) {
  }

  resetLookupValueProcessed() {
    if (this.lookupValues)
      this.lookupValues.forEach(o => {
        o.processed = false;
      });
  }
  public ngOnInit() {
    let self: MasterDetailComponent = this;
    if (this.detailsRouteUrl) {
      if (this.parent && this.parent.entityIdChange) {
        this.entityId = this.parent.entityId;
        this.parent.entityIdChange.subscribe(entityId => {
          this.entityId = entityId;
        })
      }
      else
        self._subscriptions.push(
          self.route.params.subscribe(
            params => {
              if (params.id) {
                self.selectedItem = { id: params.id };
                if (!self._detailComponentLoaded)
                  self.loadDetailComponent();
              }
              else self.selectedItem = null;
            }
          )
        );
    }
    else {
      if (this.parent && this.parent.entityIdChange) {
        this.entityId = this.parent.entityId;
        this.parent.entityIdChange.subscribe(entityId => {
          this.entityId = entityId;
        })
      }
      else
        self._subscriptions.push(
          self.route.params.subscribe(
            params => {
              this.lazyTable.reloadTable();
              this.selectedItem = null;
            }
          )
        );
    }

    self.processColumns(self.list.columns, self.list.model.fields);
    var selectedColumns = new Array();
    self.list.columns.forEach(o => {
      selectedColumns.push(o);
    })
    self.staticColumns = self.list.columns;

    if (self.list.endPoints.search && self.list.endPoints.search != null) {
      var newArr = new Array();
      if (self.list.model.nestedPrefix) {
        self.list.model.fields.forEach(f => {
          var exists = self.list.columns.filter(o => o.field == f.name);
          if (exists.length == 0)
            newArr.push({ field: f.name });
        })
        newArr.forEach(o => {
          self.list.columns.push(o);
        })
      }


      self.processColumns(self.list.columns, self.list.model.fields);

      if (self.list.relatedModels) {
        self.list.relatedModels.forEach(mod => {
          var arr = new Array();
          mod.fields.forEach(field => {
            arr.push({ field: field.name });
          });
          self.processColumns(arr, mod.fields);
          arr.forEach(o => {
            o.field = (mod.nestedPrefix ? mod.nestedPrefix : '') + (mod.name.substring(0, 1).toLowerCase() + mod.name.substring(1)).replace("Model", "") + '.' + o.field;
            if (!o.dbField)
              o.dbField = o.field.replace(".", "_");
            o.name = mod.name.replace("Model", "") + ' - ' + o.name;
            self.list.columns.push(o);
          });
        });
      }

    }

    self.columns = self.list.columns;
    self.selectedColumns = selectedColumns;


  }

  private processColumns(columns: Array<IColumnOptions>, fields: any) {
    this.lookupValues = new Array();
    columns.forEach(o => {

      if (o.default) {
        if (!this.lazyTable.filters)
          this.lazyTable.filters = {};
        this.lazyTable.filters[o.dbField] = o.default;
        this.lazyTable.dt.filters[o.dbField] = { value: o.default };
      }

      if (!fields[o.field])
        return;
      if (!o.name) o.name = fields[o.field].displayName;
      if (!o.fieldType) o.fieldType = fields[o.field].fieldType;
      if (typeof o.readOnly === "undefined") o.readOnly = true;
      if (!o.filterMatchMode) o.filterMatchMode = 'contains';
      if (!o.dbField)
        o.dbField = o.field;

      if (o.dataEndPoint && o.dataEndPoint.url)
        this.apiService.get(o.dataEndPoint.url).subscribe(items => {
          this.lookupValues.push({
            field: o.field,
            values: items.map(lo => {
              return { id: lo[o.dataIdField], display: lo[o.dataDisplayField] }
            }),
            processed: false
          })
          this.processLookupValues();
        })

      let control = new FormBuilderControl();
      control.controlType = new FormBuilderControlType(o.fieldType, null);
      control.displayName = o.name;
      control.bindingValue = o.field;
      control.field = o.field;

      o.formBuilderControl = control;

      if (o.formBuilderControl.controlType.viewType == ViewType.CheckBox) o.filterMatchMode = 'equals'
    })
  }

  processLookupValues() {
    var self = this;
    if (self.lookupValues && self.items && self.items.length > 0) {
      self.lookupValues.filter(o => !o.processed).forEach(lo => {
        self.items.forEach(i => {
          var lookup = lo.values.filter(z => z.id == i[lo.field]);
          if (lookup.length > 0)
            i[lo.field] = lookup[0].display;
        });
        lo.processed = true;
      })
    }
  }

  public ngOnDestroy() {
    while (this._subscriptions.length > 0) this._subscriptions.pop().unsubscribe();
  }

  public loadAddNewComponent() {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.masterDetailComponentDetailComponent);
    this.addNewDialog.clear();

    let componentRef = this.addNewDialog.createComponent(componentFactory);
    this._addNewComponent = (componentRef.instance);
    this._addNewDialogComponentLoaded = true;
  }
  public loadDetailComponent() {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.masterDetailComponentDetailComponent);
    this.detailHost.clear();

    let componentRef = this.detailHost.createComponent(componentFactory);
    this._component = (componentRef.instance);
    this._component.entity = this.masterDetailComponentDetailEntity;
    if (this._component.entity) this._component.entity.component = this._component;
    this._component.parent = this;
    this._detailComponentLoaded = true;
  }
  public advancedFilterSearch() {
    this.advancedFilters.forEach(item => {
      this.lazyTable.dt.filter(item.filter, item.field.filterName, 'contains');
    })
  }
  public clearAdvancedFilter() {
    this.advancedFilters = [];
    this.lazyTable.dt.reset();
  }



  loadItems(filterObject, selectedItem?) {

    let self: MasterDetailComponent = this;
    if (self.list.endPoints.search && self.list.endPoints.search != null) {
      this.loading = true;
      self.apiService.exec({
        data: filterObject,
        endPoint: self.list.endPoints.search,
        context: self,
        success: function (data) {
          self.resetLookupValueProcessed();
          self.items = data; if (selectedItem) self.selectedItem = selectedItem; self.loading = false;
          self.processLookupValues();
        },
        error: function (error) {
          self.loading = false;
          self.messageService.danger('Could not load page filter', 'Action');
        }
      })

      self.apiService.exec({
        data: filterObject,
        endPoint: self.list.endPoints.pagingTotalCount,
        context: self,
        success: function (data) {
          self.filterCount = data;
        },
        error: function (error) {
        }
      })
    }
    else if (self.list.dataEndPoint) {
      self.loading = true; self.filterCount = 99999;
      self.apiService.exec({
        endPoint: self.list.dataEndPoint,
        context: self,
        success: function (data) {
          self.resetLookupValueProcessed();
          self.items = data; if (selectedItem) self.selectedItem = selectedItem; self.loading = false;
          self.processLookupValues();

        },
        error: function (error) {
          self.loading = false;
          self.messageService.danger('Could not load1', 'Action');
        }
      })
    }
  }

  public loadData(item?) {
    this.lazyTable.reloadTable();
    //console.log('load data');
    //let self: MasterDetailComponent = this;
    //if (self.list.dataEndPoint) {
    //  self.loading = true;
    //  self.apiService.exec({
    //    endPoint: self.list.dataEndPoint,
    //    context: self,
    //    success: function (data) {
    //      self.resetLookupValueProcessed();
    //      self.items = data; if (item) self.selectedItem = item; self.loading = false;
    //      self.processLookupValues();
    //    },
    //    error: function (error) {
    //      self.loading = false;
    //      self.messageService.danger('Could not load', 'Action');
    //    }
    //  })
    //}

    //if (self.list.dataEndPoint) self.apiService.get(self.list.dataEndPoint.url).subscribe(items => {
    //  self.items = items;
    //  if (item) self.selectedItem = item;
    //}, error => { });
  }
  public addNew() {
    if (!this._addNewDialogComponentLoaded) this.loadAddNewComponent();
    this._addNewComponent.addNew();
    this.addNewPopupVisible = !this.addNewPopupVisible
    this.loading = false;
  }
  public saveNew() {
    let self: MasterDetailComponent = this;
    if (self._addNewComponent && self._addNewComponent.saveNew) self._addNewComponent.saveNew(function (item) {
      self.lazyTable.dt.reset();
      self.selectedItem = item;
      self.addNewPopupVisible = false;
    });
  }
  public cancelDialog() {
    this.addNewPopupVisible = false;
  }
  public save() {

    if (this._component && this._component.save) this._component.save();
  }

  deleteItem(rec) {
    let self = this;
    this.confirmationService.confirm({
      message: `Do you want to delete the record?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        self.loading = true;
        self.selectedItem = rec;
        self.apiService.exec({
          endPoint: self.list.endPoints.delete,
          context: self,
          success: function (data) {
            self.items.splice(self.items.indexOf(rec));
            self.messageService.success('Deleted item', 'Action');
            self.loading = false;
            self.selectedItem = null;
          },
          error: function (error) {
            self.loading = false;
            self.messageService.danger('Could not delete item', 'Action');
            self.loading = false;
          }
        })
      },
      reject: () => {

      }
    });
  }
}
